// extracted by mini-css-extract-plugin
module.exports = {"root":"FormErrorMessage_root__1x-MV","wrapper":"FormErrorMessage_wrapper__1URlk","img":"FormErrorMessage_img__hAdFs","list":"FormErrorMessage_list__FA1Gg"};